const ROUTES = {
  DASHBOARD: '/dashboard',
  DATA_SOURCES: '/data-sources',
  FORGOT: '/forgot',
  GRAPH: '/query/:entityId/:entityType/graph',
  HISTORY: '/',
  LOGIN: '/login',
  QUERY_PAGE: '/query',
  QUERY_PAGE_RESULT: '/query/:correlationId',
  REGISTER: '/register',
  REPORTS: '/reports',
  REPORT_WIZARD: '/reports/:reportId/:sectionId?',
  RESET_PW: '/reset-password/:idToken',
  ROLES: '/roles',
  ROLE_DETAILS: '/roles/:roleId',
  USERS: '/users',
  USER_DETAILS: '/users/:userId',
  SETTINGS: '/settings/:type',
  SUMMARY: '/query/:entityId/:entityType/summary',
  OVERVIEW: '/query/:entityId/:entityType/overview',
  TAXONOMY: '/taxonomy',
  TAXONOMY_DETAILS: '/taxonomy/:taxonomyId',
  TEAMS: '/teams',
  TEAM_DETAILS: '/teams/:teamId',
  TENANTS: '/tenants',
  TENANT_DETAILS: '/tenants/:tenantId',
  UPLOAD: '/upload',
  ATAI: '/atai',
  MULTIPLE_TARGETS: '/targets/:correlationId',
  AUTH_CALLBACK: '/auth/callback',
  STATUS: '/status',
}

export default ROUTES;
